import React from 'react'

import './styles.scss'

import lineImg from './img/line.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro249">
      <div className="intro249desktop screen">
        {typeof background !== 'undefined' && background && (
          <img src={background} className="background-image" />
        )}

        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL">
            <div className="couple-initials-xUsx1L">
              <div
                style={
                  coupleSimplifiedName.groom
                    ? {}
                    : {
                        top: 50,
                        left: '50%',
                        width: 'unset',
                        transform: 'translatex(-50%)',
                      }
                }
                className="notranslate couple-sim-lified-nam-QoDudJ titlexlmaindesktop bp1-intro249-animate-enter"
              >
                {coupleSimplifiedName.bride}
              </div>
              <img
                className="line-QoDudJ bp1-intro249-animate-enter1"
                style={coupleSimplifiedName.groom ? {} : { display: 'none' }}
                src={lineImg}
              />
              {coupleSimplifiedName.groom && (
                <div className="notranslate couple-sim-lified-nam-QNRe9p titlexlmaindesktop bp1-intro249-animate-enter2">
                  {coupleSimplifiedName.groom}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="intro249mobile screen">
        {typeof background !== 'undefined' && background && (
          <img src={background} className="background-image" />
        )}

        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL">
            <div className="couple-initials-xUsx1L">
              <div
                style={
                  coupleSimplifiedName.groom
                    ? {}
                    : {
                        top: 35,
                        left: '50%',
                        width: 'unset',
                        transform: 'translatex(-50%)',
                      }
                }
                className="notranslate couple-sim-lified-nam-QoDudJ bp2-intro249-animate-enter"
              >
                {coupleSimplifiedName.bride}
              </div>
              <img
                className="line-QoDudJ bp2-intro249-animate-enter1"
                style={coupleSimplifiedName.groom ? {} : { display: 'none' }}
                src={lineImg}
              />
              {coupleSimplifiedName.groom && (
                <div className="notranslate couple-sim-lified-nam-QNRe9p bp2-intro249-animate-enter2">
                  {coupleSimplifiedName.groom}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
